
import zhLocale from 'element-ui/lib/locale/lang/zh-CN' //引入element语言包
//需要转换的中文
const tc = {
  message: {
    info: {
      in1:"下載",
        in2: "快捷交易",
        in3:"能量秒到賬",
        in4:"租期更長，最長30天",
        in5:"範圍更大，支持3.2 万起租",
        in6:"支持多幣種支付購買",
        in7:"支持DAPP支付和轉帳租賃",
        in8:"可以預定大額能量",
        in9:"剩餘可租能量",
        in10:"能量租賃",
        in11:"接收地址",
        in12:"連接錢包獲取地址",
        in13:"請選擇地址",
        in14:"資源租用數量",
        in15: "預估可轉帳USDT",
        in16: "請輸入數量",
        in17:"資源租用時間",
        in18:"預計",
        in19:"到期被系統回收",
        in20:"支付",
        in21:"訂單資訊",
        in22:"能量",
        in23:"單價",
        in24:"较",
        in25:"燒毀省",
        in26:"詳情",
        in27:"訂單金額",
        in28:"訂單時長",
        in29:"租用數量",
        in30: "節 省",
        in31:" 折 扣",
        in32:"接收地址",
        in33:"錢包支付",
        in34:"連接錢包支付",
        in35:"地址餘額支付",
        in36:"推薦",
        in37:"帳戶餘額支付",
        in38:"地址支付",
        in39:"使用鏈上錢包進行轉帳支付",
        in40:"請在有效的時間內支付",
        in41:"到賬金額需要與下方顯示的金額一致，否則系統無法確認",
        in42:"監控支付中",
        in43:"複製收款地址",
        in44: "複製支付TRX數量",
        in45:"複製支付USDT數量",
        in46:"複製成功",
        in47:"複製失敗",
        in48:"支付成功",
        in49:"支付取消",
        in50:"請先連接TronLink錢包",
        in51:"連接操作頻繁，請手動連接錢包",
        in52:"連接錢包被取消",
        in53:"交易失敗",
        in54:"請輸入接收地址",
        in55:"請選擇租用時間",
        in56:"能量租賃",
        in57:"首頁",
        in58: "能量租用",
        in59:"租用記錄",
        in60:"API檔案",
        in61:"APP下載",
        in62:"個人中心",
        in63:"登入",
        in64:"更改密碼",
        in65:"登出",
        in66:"新密碼",
        in67:"確認密碼",
        in68:"提交",
        in69:"請輸入密碼",
        in70:"請再次輸入密碼",
        in71:"兩次輸入密碼不一致",
        in72: "能量交易平臺",
        in73:"便宜、 便捷、 快速、 高效、 安全",
        in74:"是一個TRON能量交易平臺，我們提供TRON能量交易服務，讓TRON能量交易更加便捷、安全、快速",
        in75:"平臺下單",
        in76:"操作簡單",
        in77:"數據詳細",
        in78:"支持掃碼付款",
        in79:"Dapp付款",
        in80:"前往下單",
        in81:"Android下單",
        in82:"IOS下單",
        in83:"API下單",
        in84:"什麼是能量？ 能量是免費的嗎？",
        in85:"TRON網絡中的資源有3種：頻寬，能量，存儲。 得益於波場獨有的設計模型，TRON網絡中的存儲資源幾乎是無限的。 TRON網絡引入了Bandwidth Point和Energy兩種可以進行量化的資源。 其中Bandwidth Point表示頻寬資源，Energy表示能量資源。",
        in86: "我們在比特幣、乙太坊上轉帳時需要通過BTC、ETH來支付手續費。 在波場進行轉帳時消耗的是頻寬和能量。",
        in87:"比特幣和乙太坊立下的規矩是，代幣轉帳需要用BTC和ETH來支付，而波場立下的規矩則是用能量和頻寬來支付。 波場上有兩類常見租客（兩類常見的代幣格式）：TRC-10和TRC-20。 轉帳TRX和TRC-10代幣時需要消耗頻寬，轉帳TRC-20代幣時需要消耗頻寬和能量。",
        in88:"如果你不知道代幣格式，可以在資產首頁點擊該代幣，進入交易記錄介面後再點擊右上角，進入TRONSCAN即可查看其代幣格式，例如波場上的USDT就是TRC-20格式",
        in89:"波場帳戶能量不是免費的，需要凍結TRX獲取能量。 也可以向能量交易平臺租能量。 假如帳戶中有100萬能量，使用完畢後，會慢慢恢復，24小時恢復滿100萬。 凍結（租用）默認最少1小時，當1小時後帳戶取消凍結（租用到期）時，通過凍結（租用）獲得的能量也將自動清零。",
        in90:"能量有什麼用？",
        in91:"能量主要可在以下幾種場景用於消耗（以下消耗數據為鏈上數據概攬，為大概數據，實際準確消耗數據需操作之後區塊瀏覽器査詢所得數據。",
        in92:"消耗",
        in93:" TRC20代幣，消耗頻寬和能量，例如USDT是20代幣，轉帳一筆需消耗31895能量和345頻寬，需要抵扣能量13.39TRX和頻寬0.345TRX左右。",
        in94:" 智慧合約 消耗",
        in95:"調用智慧合約，需消耗頻寬和能量。 例如SUNSWAP買賣交易，均是智慧合約互動，需消耗帳戶中的能量和頻寬。",
        in96:"如何獲得能量？",
        in97:"方法一：燃燒TRX",
        in98:"如果帳號沒有足够能量，轉帳時會自動燃燒TRX以抵扣轉帳所需的頻寬和能量。 相比消耗能量，燃燒TRX顯然並不划算。",
        in99:"方法二：凍結TRX",
        in100: "點擊資產首頁的能量/頻寬，進入Tron資源管理介面，選擇想獲得的資源類型，輸入需凍結的TRX數量，獲得的能量=凍結的TRX /全網獲得能量凍結的總TRX *總能量限制。 （這是基於凍結的TRX為所有用戶平均分配的固定能量），凍結後的TRX在3天后可以解凍取回。 如果您有大量閒置TRX，可以考慮這種方法。",
        in101:"方法三:租用能量",
        in102:"可以通過本平臺進行能量租賃的管道來節省手續費，能量租賃既不需要凍結大量TRX，也不用燃燒更多TRX，還可節省至少80%的手續費，以租用100萬能量為例，若直接燃燒TRX，3天需要燃燒大約1266TRX，使用用本平臺租用100萬能量只需要120TRX左右，節省了90%≈1140TRX。",
        in103:"如何租用能量？",
        in104:"可以通過本平臺去",
        in105:"租用能量",
        in106:"支付成功後，能量什麼時候到賬？",
        in107:"付款完成後，能量最快3秒內到賬。 由於廣播延遲等原因，極少數情况，會存在5到10分鐘的延遲。",
        in108:"能量使用後多久能恢復滿？",
        in109:"能量使用後將會在24小時內恢復滿。",
        in110:"訂單可以撤回嗎？",
        in111:"訂單生成後，暫不支持撤回",
        in112:"tel能量群",
        in113:"客服",
        in114: "複製成功",
        in115:"複製失敗",
        in116:"請輸入郵箱",
        in117:"請輸入驗證碼",
        in118:"獲取驗證碼",
        in119:"請輸入郵箱",
        in120:"請輸入密碼",
        in121:"確定",
        in122:"密碼登入",
        in123:"驗證碼登入",
        in124:"請輸入正確的郵箱",
        in125:"驗證碼已發送",
        in126:"請輸入密碼",
        in127:"餘額：",
        in128: "充值",
        in129:"餘額明細",
        in130:"訂單金額",
        in131:"餘額變更前",
        in132:"餘額變更後",
        in133:"訂單編號",
        in134:"操作時間",
        in135:"請使用波場瀏覽器或手機錢包進行轉帳。",
        in136:"請核對錢包地址後再轉帳，若轉帳後沒查到充值金額，可聯系客服找回。",
        in137:"轉帳金額必須大於1TRX。",
        in138:"當前地址僅支持TRX或USDT（TRC20）轉帳。",
        in139:"下單",
        in140:"狀態査詢",
        in141:"配寘査詢",
        in142: "餘額查詢",
        in143:"訂單進度",
        in144:"資源類型",
        in145:"能量",
        in146:"租用時間",
        in147:"完成數量",
        in148:"接收地址",
        in149:"創建時間",
        in150:"回收時間",
        in151:"代理Hash",
        in152:"查看",
        in153:"暫無數據",
        in154:"次",
        in155:"支付倒數計時",
        in156: "消費TRX",
        in157:"下單介面",
        in158:"請求數據",
        in159:"賬戶",
        in160:"密碼",
        in161:"能量接收地址",
        in162:"能量數量，整數",
        in163:"租用時長h代表小時d代表天數僅支持1h、1d、3d及更多天數時間",
        in164:"返回數據：code=200是成功，其他為失敗",
        in165:"訂單狀態通過訂單號去査詢",
        in166:"狀態査詢介面",
        in167:"租用能量數",
        in168:"訂單編號",
        in169:"租用地址",
        in170: "單價SUN",
        in171:"租用時長",
        in172:"付款金額trx",
        in173:"租用Hash",
        in174:"租用狀態1未租用2租用中3租用成功4租用失敗",
        in175:"配寘査詢介面",
        in176:"下單最小數量",
        in177:"當前剩餘能量額度",
        in178:"是否可以下單",
        in179:"1小時單價SUN",
        in180:"1天單價SUN",
        in181:"3天單價SUN",
        in182:"其他單價SUN",
        in183:"餘額查詢介面",
        in184: "能量轉租",
       


      in185:"詳情",
      in186:"傭金：",
      in187:"提現",
      in188:"新增轉租",
      in189:"能量開關",
      in190:"綁定地址",
      in191:"訂單編號",
      in192:"轉租配寘",
      in193:"能量",
      in194:"價格",
      in195:"最大翻倍",
      in196:"訂單備註",
      in197:"創建時間",
      in198:"操作",
      in199:"同步到機器人",
      in200:"删除",
      in201:"確認删除嗎？",
      in202:"提示",
      in203:"確定",
      in204:"取消",
      in205:"綁定轉帳地址",
      in206:"請輸入資源接收地址",
      in207:"轉租能量配寘",
      in208:"能量數量",
      in209:"請輸入能量數量",
      in210:"TRX價格",
      in211:"請輸入TRX價格",
      in212:"最大翻倍",
      in213:"請輸入最大翻倍數",
      in214:"删除",
      in215:"新增",
      in216:"訂單備註",
      in217:"請填寫訂單備註，選填",
      in218:"保存",
      in219:"下一步",
      in220: "推薦碼，非必填",
      in221:"管理",
      in222:"地址管理",
      in223:"傭金餘額明細",
      in224:"添加",
      in225:"添加地址",
      in226: "請輸入地址",

      in227:"系統公告",
      in228: "公告",
      
      in229:"通過將自已帳號中的餘額轉租給他人，賺取差價。 請在上面設定中設定您的收取trx的地址及每次轉租價格和數量通常為65000和131000",
      in230:"邀請好友",
      in231:"我的推薦碼",
      in232:"我的推薦連結",
      in233:"二維碼邀請",
  
  
     
      },
    
  },
  ...zhLocale
}
export default tc;



// WEBPACK FOOTER //
// ./src/assets/i18n/langs/zh_TC.js